<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/onSearchAllStatus?categoryTypeCode=ASSETS_NAME&sortField=categoryId&"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <assets-name-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import AssetsNameCreate from "./AssetsNameCreate.vue";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "assets-name-list",
    components: {AssetsNameCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách tên tài sản",
            formCreateName: "Thêm mới",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryName",
                    text: "Tên",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.materialStatus,
                    itemText: "text",
                    itemValue: "value",
                    width: "20%",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "120px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới';
                this.visibleCreateDialog = true;
            } else {
                this.category = item;
                this.formCreateName = 'Cập nhật';
                this.visibleCreateDialog = true;
            }
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
